<template>
  <div class="wrapper">
    <!-- Add Splash page component -->
    <transition name="fade">
      <SplashComponent v-if="isSplashVisible" />
    </transition>

    <div class="overlay" v-if="isMenuOpen" @click="toggleMenu"></div>
    <div class="button-container">
      <div class="menu-icon" @click="toggleMenu">
      <img v-if="!isMenuOpen" alt="svgImg" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCI+CjxwYXRoIGQ9Ik0gMCA5IEwgMCAxMSBMIDUwIDExIEwgNTAgOSBaIE0gMCAyNCBMIDAgMjYgTCA1MCAyNiBMIDUwIDI0IFogTSAwIDM5IEwgMCA0MSBMIDUwIDQxIEwgNTAgMzkgWiI+PC9wYXRoPgo8L3N2Zz4="/>
    </div>
    </div>
    
    <div class="menu" :style="menuStyle" @mouseleave="closeMenuIfNotClicked"> 
      <ul>
        <li @click="openTrailerModal">Trailer</li>
        <li @click="scrollTo('top')">Top</li>
        <li @click="scrollTo('introduction')">Introduction</li>
        <li @click="scrollTo('story')">Story</li>
        <li @click="scrollTo('cast')">Cast</li>
        <li @click="scrollTo('directors')">Director's Statement</li>
        <li @click="scrollTo('credits')">Credits</li>
        <li @click="scrollTo('theater')">Theater</li>

      </ul>
    </div>

    <TopComponent id="top" />
    <IntroductionComponent id="introduction" />
    <StoryComponent id="story" />
    <CastComponent id="cast" />
    <DirectorsComponent id="directors" />
    <SoundtrackComponent id="soundtrack" />
    <CreditsComponent id="credits" />
    <TheaterComponent id="theater" />


    <div class="modal_wrap"  v-if="isModalOpen">
      <div class="modal">
        <div class="iframe_close_button">
        <button class="close-button" @click="closeModal">&times;</button>
        <iframe width="560" height="315" src="https://www.youtube.com/embed/6rzGMHY3cSE?rel=0" 
        title="YouTube video player" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowfullscreen></iframe>
        </div>
      </div>

    </div>



  </div>



</template>

<script>

import TopComponent from './components/TopComponent.vue'
import IntroductionComponent from './components/IntroductionComponent.vue'
import StoryComponent from './components/StoryComponent.vue'
import CastComponent from './components/CastComponent.vue'
import DirectorsComponent from './components/DirectorsComponent.vue'
import SoundtrackComponent from './components/SoundtrackComponent.vue'
import CreditsComponent from './components/CreditsComponent.vue'
import SplashComponent from './components/SplashComponent.vue' 
import TheaterComponent from './components/TheaterComponent.vue'


export default {
components: {
  // FontAwesomeIcon,
  TopComponent,
  IntroductionComponent,
  StoryComponent,
  CastComponent,
  DirectorsComponent,
  SoundtrackComponent,
  CreditsComponent,
  SplashComponent, 
  TheaterComponent,

},

data() {
  return {
    isMenuOpen: false,
    isSplashVisible: true, 
    isModalOpen: false,
    videoId: '6rzGMHY3cSE',

  };
},
methods: {

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  },
  closeMenu() {
    this.isMenuOpen = false;
  },
  
  closeMenuIfNotClicked() {
    if (!this.preventClose) {
      this.closeMenu();
    }
    this.preventClose = false;
  },

  scrollTo(to) {
    const element = document.getElementById(to);
    if (element) {
      this.preventClose = true; // Set this to prevent close on mouseleave
      this.closeMenu();
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // this.toggleMenu(); // メニューを閉じる
  },
    hideSplash() {  // Add this method
    this.isSplashVisible = false;
  },

  openTrailerModal() {
      this.isModalOpen = true; 
      this.closeMenu();
    },

  closeModal() {
      this.isModalOpen = false;
  },
  
},

computed: {
  menuIcon() {
    return this.isMenuOpen ? this.timesIcon : this.barsIcon;
  },
  menuStyle() {
    return this.isMenuOpen
      ? { transform: 'translateX(0)', opacity: 1 }
      : { transform: 'translateX(-100%)', opacity: 0 };
  },
},
mounted() {
    setTimeout(() => {
      this.openTrailerModal();
    }, 5200); //
    setTimeout(() => {
      this.isSplashVisible = false;
    }, 7000); // 
  },
};
</script>


<style>

/* Closeボタンのスタイル */
.close-button {
  position: absolute;
  top: -44px;
  right: 8px;
  background-color: rgba(183, 183, 204, 0.85);
  border: none;
  padding-top: 0px;
  margin-top: 0;
  padding-bottom: 2px;
  padding-left: 2px;
  padding-right: 2px;
  cursor: pointer;

  opacity:80% ;
  font-size: 30px;
  color: white;

}

.modal-closed {
  pointer-events: none;
}
.modal_wrap{
  /* border: 4px solid rgb(79, 35, 210);  */
  display: flex;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  justify-items: center;
  align-items: center;
 
}

.modal {
  position: relative;
    /* border: 5px solid rgb(194, 191, 5);  */
    width: 100%;
    height: 0;
    flex-wrap: wrap;
    margin-top: 2vh;
    padding-top: 56.25%;
}

.iframe_close_button{
  position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%, -50%);
    width:100%;
    height:100%;
    max-width: 560px;
    max-height:315px;
}



.modal iframe{
    position: absolute;
    top: 50%;
    left:50%;
    transform: translate(-50%, -50%);
    width:100%;
    height:100%;
    max-width: 560px;
    max-height:315px;
  }




/* Add these */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

html,body {
  /* border: 1px solid rgb(210, 35, 108);  */
  margin: 0;
  padding:0;
  width:100%;
  min-width: 240px;
  -webkit-text-size-adjust: 100%;	
}

body.disable-scroll, html.disable-scroll {
  overflow: hidden;
  position: fixed;
  width: 100%;
}



.wrapper{
  /* border: 3px solid rgb(199, 210, 35);  */
  position: relative;
  width:100%;
  max-width: 100%;
  top:10%;
}


.menu {
  position: fixed;
  /* border: 3px solid rgb(199, 210, 35);  */
  top: 0;
  left: 0px;
  width:25%;
  min-width:240px ;
  height: 100%;
  background-color: rgba(183, 183, 204, 0.85);
  transition: transform 0.3s ease, opacity 0.3s ease;
  font-size: calc(0.6vw + 1rem);
  font-family:'Shippori Mincho', sans-serif;

  color: white;
  z-index: 1001;
  white-space: nowrap;

  align-items: center;

}


ul{
  /* border: 3px solid rgb(123, 255, 0);  */
  position: absolute;
  top:25vh;
  left:0px;
  width: 90%;
  text-align: center;
  padding-left: 1vw;
}
li{
  list-style: none;
  margin-bottom: 2vh;
}

.button-container{
  position: fixed; 
  top: 20px;
  left: 10px;
  z-index: 999;
}


/* .icon-open {
  color: rgb(255, 255, 255);

} */

/* .icon-closed {
  color: rgb(8, 8, 8);
  filter:drop-shadow(0 0 1px #424242)
} */

.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0);  /* You can adjust color and opacity */
  z-index: 5;  /* Make sure it's less than your menu's z-index */
}


.menu-icon img {
  padding-top: 2vh;
  padding-left: 4vw;
  width: 30px; /* mobile */
  height: 30px;
}


@media (max-height: 380px) { 

.norm_br{
display: none; 
}

.menu-icon img {
  width: 40px;
  height: 40px;
}


ul{
  /* border: 3px solid rgb(255, 0, 55);  */
  position: absolute;
  top:1vh;
  left:0px;
  width: 90%;
  text-align: center;
  padding-left: 1vw;
}
li{
  list-style: none;
  margin-bottom: 2vh;
}

}


@media (min-width: 200px) { 

.norm_br{
display: none; 
}

.menu-icon img {
  width: 40px;
  height: 40px;
}

.logo {
  /* border: 1px solid rgb(255, 21, 0); */

  /* top: 52%;             */
  right: 10%;            
  width: auto;
  height:100%;

  /* transform: translateY(-50%);  */
  z-index: 3;
  opacity: 0.85;
}

.col_a{
  /* border: 2px dashed rgb(98, 255, 0); */
  width:25vw;
  height: 100vh;
}
.col_b{
  /* border: 2px dashed rgb(0, 55, 255); */
  width:25vw;
  height: 100vh;
}
.col_c{
  /* border: 2px dashed rgb(255, 0, 157); */
  width:35vw;
  height: 65vh;
}
.col_d{
  /* border: 2px dashed rgb(238, 255, 0); */
  padding-top: 1vh;
  width:15vw;
  height: 65vh;
  min-height: 370px;
  min-width:100px;
}
}




@media (min-width: 375px) { 

  .norm_br{
  display: none; 
  }

  .menu-icon img {
    width: 40px;
    height: 40px;
  }

  .col_d{
  /* border: 2px solid rgb(238, 255, 0); */
  width:25vw;
  height: 65vh;
  min-height: 300px;

}

}


@media (min-width: 768px) { /* tab */

  .norm_br{
  display: none; 
  }


  .menu-icon img {
    width: 40px;
    height: 40px;
  }

  .col_d{
  /* border: 2px dashed rgb(255, 0, 204); */
  width:25vw;
  height: 60vh;
  min-height: 340px;
  min-width:125px;
  margin-top: 5vh;
}


}

@media (min-width: 1024px) { /* Desktop */

  .norm_br{
  display: block; 
  }

  .menu-icon img {
    width: 50px;
    height: 50px;
  }

  .menu-icon {
    font-size: 1em; /* Desktop */
  }

  .col_d{
  /* border: 3px dashed rgb(0, 255, 72); */
  width:25vw;
  height: 85vh;
  padding-top: 5vh;
  min-height: 400px;
}
}



@media screen and (min-width:1400px){
 .norm_br{
  display: block; 
  }

  .col_d{
  /* border: 2px dashed rgb(255, 0, 30); */
  padding-top: 1vh;
  width:25vw;
  height: 80vh;
  min-height: 400px;

}
}


@media screen and (min-width:1680px){
 .norm_br{
  display: block; 
  }

  .col_d{
  /* border: 4px dashed rgb(21, 0, 255); */
  
  width:25vw;
  height: 87vh;
  min-height: 700px;

}
}


@media screen and (min-width:1920px){
 .norm_br{
  display: block; 
  }

  .col_d{
  /* border: 2px solid rgb(0, 213, 255);   */
  width:25vw;
  height: 85vh;
  min-height: 700px;

}
}







</style>



